import axios from 'axios'
import { settings } from './settings'
import { store } from './store'

class Api {
    constructor() {
        this.api = axios.create({
            baseURL: `${settings.siteUrl}/api/`
        });

        this.api.interceptors.request.use((config) => {
            if(store.state.token) {
                config.headers = { 'x-access-token' : store.state.token };
            }
            return config;
        });
    }

    get(url, config) {
        return this.api.get(url, config);
    }

    post(url, data, config) {
        return this.api.post(url, data, config);
    }

    delete(url, config) {
        return this.api.delete(url, config);
    }
}

const api = new Api();
export { api }


// WEBPACK FOOTER //
// ./src/framework/api.js